module.exports = __webpack_public_path__ + "img/logo-full.5e0db143.svg";